import listDebts from './list';

const subscribe = (store) => {
  listDebts.subscriber.subscribe(store);
};

export default {
  subscribe,
};
